import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiPaths } from './apiPaths';

const baseQuery = fetchBaseQuery({
    baseUrl: apiPaths.mamutilsBaseUrl(),
    // credentials: 'include',
    // prepareHeaders: (headers) => setHeaders(headers),
});

export const mamutilsApi = createApi({
    reducerPath: 'mamutilsApi',
    baseQuery: baseQuery,
    endpoints: () => ({}),
    tagTypes: ['CollectionMetadata', 'Collection'],
});

export default mamutilsApi;
